import { render, staticRenderFns } from "./LessonRoom.vue?vue&type=template&id=0533daa8&scoped=true"
import script from "./LessonRoom.vue?vue&type=script&lang=js"
export * from "./LessonRoom.vue?vue&type=script&lang=js"
import style0 from "./LessonRoom.vue?vue&type=style&index=0&id=0533daa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533daa8",
  null
  
)

export default component.exports